import {DialogController} from 'aurelia-dialog';
import {inject} from "aurelia-framework";
import {FormField} from "../../../form/object/form-field";
import {FlashService} from "../../../flash/flash-service";

@inject(
    DialogController,
    FlashService,
)
export class UpdateContingentCalendarView {
    constructor(
        dialogController,
        flashService,
    ) {
        this.dialogController = dialogController;
        this.flash = flashService;

        this.fields = [];
    }

    async activate(context) {
        const dummyFormService = {
            change: () => {
            },
        };

        this.fields = [
            new FormField(
                dummyFormService,
                {
                    'label': 'sio.field.amount',
                    'type': 'number',
                    'required': true,
                },
                'amount',
                0,
            ),
            new FormField(
                dummyFormService,
                {
                    'checkboxLabel': 'price.models.contingent-calendar.display.bulkOperations.update-contingent-calendar.field.isExact.label',
                    'help': 'price.models.contingent-calendar.display.bulkOperations.update-contingent-calendar.field.isExact.help',
                    'type': 'checkbox',
                    'required': false,
                },
                'isExact',
                true,
            ),
            new FormField(
                dummyFormService,
                {
                    'label': 'price.models.contingent-calendar.display.bulkOperations.update-contingent-calendar.field.overbookingFactor.label',
                    'type': 'number',
                    'subType': 'percentage',
                    'required': false,
                },
                'overbookingFactor',
                null,
            ),
            new FormField(
                dummyFormService,
                {
                    'checkboxLabel': 'price.models.contingent-calendar.display.bulkOperations.update-contingent-calendar.field.isExactOverbookingFactor.label',
                    'help': 'price.models.contingent-calendar.display.bulkOperations.update-contingent-calendar.field.isExactOverbookingFactor.help',
                    'type': 'checkbox',
                    'required': false,
                },
                'isExactOverbookingFactor',
                false,
            ),
        ];

        this.title = context.title;
        this.onSave = context.onSave;
        this.loading = false;
    }

    async ok() {
        this.loading = true;

        return this.onSave({
            amount: this.fields[0].getValue(),
            isExact: this.fields[1].getValue() || false,
            overbookingFactor: this.fields[2].getValue(),
            isExactOverbookingFactor: this.fields[3].getValue() || false,
        }).then((response) => {
            return Promise.resolve(this.dialogController.ok())
        }).catch((error) => {
            this.loading = false;
            this.flash.error(
                error?.data?.localizedMessage
                ?? error?.data?.message
                ?? error
                ?? 'form.communication_error_message'
            );
            throw error;
        });
    }
}
